import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { LogIn } from 'lucide-react';
import { Button } from '../components/ui/button';

const LOGO_URL = 'https://customer-assets.emergentagent.com/job_job-quotes/artifacts/mtux4tav_Logo%20001%20-%20Kenscho%20Design.png';
const HERO_URL = 'https://images.unsplash.com/photo-1769721209842-e46c60e7fbf9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBjb25zdHJ1Y3Rpb258ZW58MHx8fHwxNzc2MjY3NDMyfDA&ixlib=rb-4.1.0&q=85';

export default function LoginPage() {
  const { login } = useAuth();

  return (
    <div className="min-h-screen flex" data-testid="login-page">
      {/* Left panel */}
      <div className="flex-1 flex flex-col justify-center px-8 md:px-16 lg:px-24 bg-white">
        <div className="max-w-md w-full mx-auto">
          <div className="mb-12">
            <img src={LOGO_URL} alt="Kenscho Design" className="h-20 w-20 rounded-md object-cover mb-6" />
            <h1 className="text-4xl sm:text-5xl tracking-tight font-bold text-[#1A1D1C]" style={{ fontFamily: "'Chivo', sans-serif" }}>
              Kenscho Design
            </h1>
            <p className="mt-3 text-base text-[#6B7A73] leading-relaxed" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
              Estimate Management Portal
            </p>
          </div>

          <div className="space-y-6">
            <div>
              <p className="text-sm text-[#3A423E] mb-6 leading-relaxed" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
                Sign in to create, manage, and export professional construction estimates for your projects.
              </p>
            </div>

            <Button
              data-testid="google-login-btn"
              onClick={login}
              className="w-full bg-[#2D6B68] text-white hover:bg-[#235552] rounded-md px-6 py-3 h-12 font-medium text-base transition-colors flex items-center justify-center gap-3"
            >
              <LogIn className="w-5 h-5" />
              Sign in with Google
            </Button>

            <div className="pt-6 border-t border-[#E6EBE8]">
              <p className="text-xs text-[#6B7A73]" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
                RBQ 5829-4596-01 &middot; CCQ 930-073
              </p>
              <p className="text-xs text-[#6B7A73] mt-1">
                Saint-Calixte, Quebec &middot; kenscho.ca
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Right panel - hero image */}
      <div className="hidden lg:flex flex-1 relative">
        <img src={HERO_URL} alt="Construction" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-black/30" />
        <div className="absolute bottom-12 left-12 right-12">
          <p className="text-white/90 text-lg font-medium" style={{ fontFamily: "'Chivo', sans-serif" }}>
            Professional estimates, organized.
          </p>
          <p className="text-white/60 text-sm mt-2" style={{ fontFamily: "'IBM Plex Sans', sans-serif" }}>
            Create from templates, track status, export to PDF.
          </p>
        </div>
      </div>
    </div>
  );
}
